<template>
    <b-card class="mb-0">
      <profile-form ref="profileform"></profile-form>
      <b-card-footer class="d-flex flex-row-reverse">
        <b-button class="btn btn-primary" @click="saveProfile" variant="outline-primary">Save</b-button>
      </b-card-footer>
    </b-card>
</template>
<script>
import ProfileForm from '#/ui/Components/User/UserProfileForm.vue';

export default {
  components: {
    ProfileForm,
  },
  methods: {
    saveProfile() {
      console.info('saving profile');
      this.$refs.profileform.saveProfile();
    },
  },
};
</script>
<style>

</style>
